<template>
  <div id="main">
    <div class="main">
      <left-nav title="小学辅导" navCode="318"></left-nav>
      <mid-swiper :adCode="56" :navList="primaryMainNav" secNavIndex=4>
        <a href="http://youer.xdf.cn/">幼儿</a>
        <a href="http://xiaoxue.xdf.cn/">小学</a>
      </mid-swiper>
      <right-form :consultList="consult" :styles="style">
        <div class="yx_zhuceimg">
          <img src="http://file.xdf.cn/neworiental/images/yx_zhuceimg.png?1903">
        </div>
      </right-form>
      <div style="clear: both"></div>
    </div>
    <div style="clear: both"></div>
  </div>
</template>

<script>
import LeftNav from '@/common-components/Channelleftnav'
import MidSwiper from '@/common-components/Channelmidswiper'
import RightForm from '@/common-components/Rightform'
import { consult } from 'js/primary/consult.js'
import { primaryMainNav } from 'js/primary/mainnav'
export default {
  name: 'premaryHomePage',
  data () {
    return {
      primaryMainNav,
      consult,
      style: 'top: -40px;'
    }
  },
  props: {
    secNavIndex: Number
  },
  components: {
    LeftNav,
    MidSwiper,
    RightForm
  }
}
</script>

<style scoped lang="stylus">
@import '~styles/varibles.styl'
#main
  width: 100%
  margin-bottom: 20px
  .main
    width: $defaultwidth
    margin: 0 auto
    position: relative
    min-height: 360px
.yx_zhuceimg
  position: relative
  width: 252px
  height: 102px
  img
    position: absolute
    left: -4%
</style>



// WEBPACK FOOTER //
// src/pages/primaryschool/components/swiper/Swiper.vue